export const theme = {
  FILTER_SIDEBAR_WIDTH: '210px',
  HEADER_HEIGHT: '96px',
  INFO_PANEL_WIDTH: '420px'
}